import { Enums } from "../../models/common"
import { OpAlarmDef } from "../../models/core"

//#region Public Types

export const ALARM_DEFINITION_SERVICE_NAME = 'alarmDefinitionService'
export const ALARM_DEFINITION_SERVICE_PROVIDER_NAME = 'alarmDefinitionServiceProvider'

//#endregion

export class AlarmDefinitionService {

    public static get LOG_PREFIX(): string { return '[SIMAX.Module.Common.AlarmDefinition]' }
    public static get REFERENCE_TYPE(): Enums.ReferenceType { return Enums.ReferenceType.IdAlarmDef };
    public static get FILE_NAME_PREFIX(): string { return 'alarm-definitions' };
    public static get SINGLE_FILE_NAME_PREFIX(): string { return 'alarm-definitions-single' };
    public static get BULK_FILE_NAME_PREFIX(): string { return 'alarm-definitions-bulk' };
    

    // #region Ctor

    constructor() { }

    // #endregion


    // #region Public Methods

    public getSupportedTransmissionTypes(): Enums.TransmissionType[] {
        return [
            Enums.TransmissionType.Text,
            Enums.TransmissionType.EMail
        ]
    }

    public getAlarmDefTemplates(source: OpAlarmDef[]) {
        return source == null
            ? null
            : source.filter((alarmDef: OpAlarmDef) => this.isAlarmDefTemplate(alarmDef))
    }

    public isAlarmDefTemplate(alarmDef: OpAlarmDef) {
        return alarmDef != null && alarmDef.idAlarmDef == 0
    }

    // #endregion


    // #region Private Methods


    // #endregion
}

export class AlarmDefinitionServiceProvider
    implements ng.IServiceProvider
{

    //#region IServiceProvider Implementation 

    public $get = [function () {
        return new AlarmDefinitionService()
    }]

    //#endregion
} 
